"use client";

import { PAGE_MAX_WIDTH } from "@/app/layout/LayoutConstants";
import { Box, styled } from "@mui/material";

export const BoxWithGutters = styled(Box)(({ theme }) =>
  theme.unstable_sx({
    maxWidth: PAGE_MAX_WIDTH,
    padding: theme.spacing(0, 2),
    marginLeft: "auto",
    marginRight: "auto",
  }),
);
